import { body, masthead } from "../elements";
import { getMastheadHeight } from "./elHeights";

export function useBodySetUp() {
  function setMastheadHeight() {
    body.style.setProperty("--offset-masthead", getMastheadHeight());
  }

  const mastheadResizeObserver = new ResizeObserver((entries) => {
    entries.forEach(() => {
      setMastheadHeight();
    });
  });
  mastheadResizeObserver.observe(masthead);
}
